export default { sha: 'ee6d2dcdcaa38667df0f4301acd79d59f7bdce90', buildNumber: 'undefined' }
